import $ from 'jquery';

const modals = () => {
  $('.inline-modal > a').each(function() {
    $(this).magnificPopup({
      mainClass: 'mfp-zoom-out',
      items: {
        src: $($(this).attr('href')),
        type: 'inline',
      },
    });
  });
};
export default modals;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ct-cubed-chisel/src/scripts/modules/modals.js